import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import withCustomStyles from "./GChoice.style";

const Check = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="m5 12 5 5 9-10" />
  </svg>
);

// Single choice with more than a label: delivery slots, payment methods,
// addresses. A real (visually hidden) radio inside a label.
const GChoice = ({
  classes,
  className,
  name,
  value,
  checked,
  onChange,
  disabled,
  unavailableLabel,
  icon,
  title,
  meta,
  aside,
  children
}) => (
  <label
    className={classnames(
      classes.card,
      { [classes.checked]: checked, [classes.unavailable]: disabled },
      className
    )}
  >
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      className={classes.radio}
    />
    {icon && (
      <span className={classes.icon} aria-hidden="true">
        {icon}
      </span>
    )}
    <span className={classes.body}>
      <span className={classes.title}>{title}</span>
      {meta && <span className={classes.meta}>{meta}</span>}
      {children}
    </span>
    {disabled && unavailableLabel ? (
      <span className={classes.full}>{unavailableLabel}</span>
    ) : (
      aside
    )}
    {checked && (
      <span className={classes.check}>
        <Check />
      </span>
    )}
  </label>
);

GChoice.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  unavailableLabel: PropTypes.node,
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  meta: PropTypes.node,
  aside: PropTypes.node
};

GChoice.defaultProps = {
  checked: false,
  disabled: false,
  unavailableLabel: "Full"
};

export default withCustomStyles(GChoice);
